// extracted by mini-css-extract-plugin
export default {"link":"WrBefx","image":"jMZF8M","root":"JnBkN7"};